import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Change } from '../../../modules/dashboard/models/dashboard.types';
import { Icon } from '../../../shared/ui/Icon/Icon';
import HistoryView from './HistoryView';
import { changesMock } from '../../../modules/dashboard/hooks/use-dashboard-mock.hook';
import { FavoriteHistoryItem } from './FavoriteHistoryItem';
import { useMutation } from 'react-query';
import { useFetch } from '../../../shared/hooks/use-fetch.hook';
import { useUsersHttp } from '../../../modules/user/hooks/use-users-http.hook';
import { H2 } from '../../../shared/ui/H2/H2';
import { WidgetFavoriteGroupsUsers } from './FavoriteGroupUser';
import { WidgetFavoriteTools } from './WidgetFavoriteTools';
import { Box } from '@mui/material';
import { thinScroll } from '../../../shared/models/shared.types';

export const ChangesPage = ({
  username,
}: // changes,
{
  username: string;
  // changes: Change[];
}) => {
  const { t } = useTranslation();
  const { handleError, handleRetry } = useFetch();
  const { userChangesGet } = useUsersHttp(); // TODO Fix newUserChangesGet

  const [changes, setChanges] = useState<Change[]>([]);
  const favoriteChanges = changes.filter((change) => change.favorite && change);

  // GET changes mutation
  const changesGetMutation = useMutation(() => userChangesGet(), {
    retry: (failureCount, error: any) => handleRetry(failureCount, error),

    onSettled(data, error) {
      if (data) {
        setChanges(data);
      }
      if (error) {
        const errRes = error?.response;
        if (errRes) {
          setChanges(changesMock); // TODO fix setChanges([])
        }
      }
    },
  });

  useEffect(() => {
    changesGetMutation.mutate();
  }, []);

  return (
    <Box
      className="w-full p-4 pl-8 h-[calc(100vh-60px)] overflow-y-auto"
      sx={{ ...thinScroll }}
    >
      {/* Header */}
      <div className="flex flex-col pt-4 mb-4 gap-2">
        <div className="flex flex-row items-center font-semibold text-lg">
          <Icon icon={['fal', 'hand-wave']} classes="mr-2" /> {t('app.hello')}{' '}
          {username},
        </div>
        <div className="flex pl-6">
          lass uns gemeinsam schauen, was aktuell ansteht. Ein Klick bringt dich
          direkt zum Tool.
        </div>
      </div>

      {/* Content */}
      <div className="flex w-full h-full">
        <div className="w-3/5">
          <HistoryView changes={changes} setChanges={setChanges} />
        </div>
        <div className="w-2/5 pl-2">
          <div className="flex flex-wrap md:flex-nowrap gap-4 p-4 min-h-[600px]">
            {/* Aufgaben */}
            <div className="flex flex-col flex-1 gap-2">
              <div className="pl-2 text-base font-semibold">Aufgaben</div>
              {favoriteChanges.length > 0 ? (
                <div>
                  {favoriteChanges.map((change) => (
                    <FavoriteHistoryItem
                      change={change}
                      onToggleFavorite={() => {}}
                    />
                  ))}
                </div>
              ) : (
                <div className="flex-1 border border-dashed border-gray-300 rounded-md p-4">
                  Hier werden Nachrichten und Updates eingeblendet, die du mit
                  der Pinnnadel als <strong>Aufgabe</strong> markiert hast.
                </div>
              )}
            </div>

            {/* Right column with two smaller cards */}
            <div className="flex-1 flex flex-col gap-2 w-full md:w-1/2">
              <div className="pl-2 text-base font-semibold">
                Favoriten(Personen & Gruppen)
              </div>
              <WidgetFavoriteGroupsUsers />
              <div className="pl-2 text-base font-semibold">
                Favoriten(Tools)
              </div>
              <WidgetFavoriteTools />
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};
